import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { TipoTributarioRequest } from '../../requests/motor-fiscal/tipo-tributario.request';
import { TipoTributarioBulkDeleteRequest } from '../../requests/motor-fiscal/tipo-tributario-bulk-delete.request';
import { GetTipoTributarioFiltroRequest } from '../../requests/motor-fiscal/get-tipo-tributario-filtro.request';
import { GetTipoTributarioResponse } from '../../responses/motor-fiscal/get-tipo-tributario.response';
import { GetTipoTributarioDetalheResponse } from '../../responses/motor-fiscal/get-tipo-tributario-detalhe.response';

@Injectable({ providedIn: 'root' })
export class TipoTributarioService extends CommonService {
  private readonly apiUrl: string = `${environment.urlApiMotorFiscal}TipoTributario`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(filtro: GetTipoTributarioFiltroRequest): Observable<GetTipoTributarioResponse> {
    let params = new HttpParams()
      .set('paginaAtual', (filtro.paginaAtual ?? 1).toString())
      .set('tamanhoPagina', (filtro.tamanhoPagina ?? 20).toString());

    if (filtro.pesquisa) params = params.set('pesquisa', filtro.pesquisa);
    if (filtro.isAtivo != null) params = params.set('isAtivo', filtro.isAtivo.toString());

    return this.httpClient
      .get<GetTipoTributarioResponse>(this.apiUrl, { ...this.addHeaderToken(), params })
      .pipe(catchError(this.handleError));
  }

  public getById(id: number): Observable<GetTipoTributarioDetalheResponse> {
    return this.httpClient
      .get<GetTipoTributarioDetalheResponse>(`${this.apiUrl}/${id}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public criar(request: TipoTributarioRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public alterar(id: number, request: TipoTributarioRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}/${id}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public excluir(id: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/${id}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public bulkDelete(request: TipoTributarioBulkDeleteRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/bulk-delete`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
